import script from "./ProductComp.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductComp.vue?vue&type=script&setup=true&lang=js"

import "./ProductComp.vue?vue&type=style&index=0&id=05050b82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05050b82"]])

export default __exports__